
import axios from 'axios'
import { defineComponent, onMounted, ref } from 'vue'

type LocalLoginUser = {
  id: number
  firstName: string
  lastName: string
  picture: string
  role: string
}

export default defineComponent({
  name: 'login',
  layout: 'login',
  setup() {
    const googleAuthUrl = `${process.env.VUE_APP_API_URL}/google`
    const isLocalLoginEnabled =
      process.env.NODE_ENV === 'development' ||
      ['localhost', '127.0.0.1'].includes(window.location.hostname)
    const users = ref<LocalLoginUser[]>([])
    const isLoading = ref(false)
    const errorMessage = ref('')

    async function fetchUsers() {
      if (!isLocalLoginEnabled) return

      isLoading.value = true
      errorMessage.value = ''

      try {
        const response = await axios.get<LocalLoginUser[]>(
          `${process.env.VUE_APP_API_URL}/dev-auth/users`
        )
        users.value = response.data
      } catch {
        errorMessage.value = 'Cannot load local users list.'
      } finally {
        isLoading.value = false
      }
    }

    async function loginAsUser(userId: number) {
      isLoading.value = true
      errorMessage.value = ''

      try {
        const response = await axios.post<{ token: string }>(
          `${process.env.VUE_APP_API_URL}/dev-auth/login/${userId}`
        )
        window.localStorage.setItem('token', response.data.token)
        window.location.assign('/')
      } catch {
        errorMessage.value = 'Cannot sign in as selected user.'
      } finally {
        isLoading.value = false
      }
    }

    onMounted(fetchUsers)

    return {
      errorMessage,
      googleAuthUrl,
      isLoading,
      isLocalLoginEnabled,
      loginAsUser,
      users
    }
  }
})
